<template>
  <div>
    <div
      v-if="!paywallOptions.showPaywall"
      class="mb-6 text-sm py-5 px-4 bg-surface-light rounded-md border border-weak flex flex-col md:flex-row items-center"
    >
      <AM3Icon
        type="information-circle"
        class="inline-block mb-2 md:mb-0 md:mr-2"
        size="md"
      />
      <p class="text-xs md:text-sm text-center md:text-left">
        <span class="font-medium">Important Information:</span> Cancellations, refunds or ticket transfers may not always be reflected
        here. Data accuracy & sync frequency can vary depending on the ticketing platform.
      </p>
    </div>

    <div
      v-paywall="paywallOptions"
      class="relative"
      :class="[!hasPermission ? 'border border-weak border-solid rounded-md' : '', paywallOptions.showPaywall ? 'max-h-[600px] overflow-hidden' : '']"
    >
      <CustomerProfileTicketPurchases :v-paywall="paywallConfig" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useStore } from 'vuex'
import CustomerProfileTicketPurchases from '@/pages/audience/[customer]/view/ticketPurchases.vue'
import AM3Icon from '@/components/am3-generic/base/icon/AM3Icon.vue'

const store = useStore()
const isFeatureEnabled = computed(() => store.getters['authModule/isFeatureEnabled'])

const isCustomerProfileFeatureEnabled = computed(() => {
  return isFeatureEnabled.value(['customer-profiles'])
})

const hasPermission = computed(() => isCustomerProfileFeatureEnabled.value)

const paywallOptions = computed(() => ({
  showPaywall: !isCustomerProfileFeatureEnabled.value,
  title: 'Unlock purchase data',
  description: 'Track purchases and attribution to see more info about your contacts.',
  buttonText: 'Upgrade Plan',
  buttonIcon: 'rocket',
  linkDestination: '/upgrade',
}))

const paywallConfig = computed(() => {
  return hasPermission.value
    ? null
    : {
        showLockIcon: true,
        title: 'Upgrade to unlock purchase data.',
        description: 'Track purchases and attribution to see more info about your contacts.',
        buttonText: 'Upgrade Now',
        buttonIcon: 'lock-closed',
      }
})
</script>
